import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import ProductsPage from "@/pages/products/page";
import ProductDetailPage from "@/pages/product-detail/page";
import CartPage from "@/pages/cart/page";
import CheckoutPage from "@/pages/checkout/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/product/:id", element: <ProductDetailPage /> },
  { path: "/cart", element: <CartPage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
